import { useEffect } from "react";
import { useDetailPageSidebar } from "@/contexts/DetailPageSidebarContext";

export function FloatingNav() {
  const { showSidebar, setShowSidebar, setOnSidebarToggleClick } = useDetailPageSidebar();

  // Keep sidebar toggle handler in context for detail pages that need it
  useEffect(() => {
    if (setOnSidebarToggleClick) {
      setOnSidebarToggleClick(() => () => setShowSidebar(!showSidebar));
      return () => {
        if (setOnSidebarToggleClick) {
          setOnSidebarToggleClick(undefined);
        }
      };
    }
  }, [setShowSidebar, setOnSidebarToggleClick, showSidebar]);

  return null;
}
